module.exports = __webpack_public_path__ + "c10d09fb0611a8b20459fc2d7104dc15.svg";